export type ContactSubmission = { id: string; email: string; description: string; website: string };
export type ContactReceipt = { id: string; emailDelivery: 'not_configured' };

export function hasContactBackend(location: Pick<Location, 'protocol' | 'hostname'> = window.location): boolean {
  return location.protocol === 'https:' && ['designforge.site', 'designforge-8km.pages.dev'].includes(location.hostname);
}

/** Explicit form submission only. No background transmission of contact fields. */
export async function submitContact(submission: ContactSubmission, fetcher: typeof fetch = fetch): Promise<ContactReceipt> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 15000);
  try {
    const response = await fetcher('/api/contact', {
      method: 'POST', credentials: 'same-origin', redirect: 'error',
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(submission), signal: controller.signal,
    });
    if (response.status === 429) throw new Error('rate_limited');
    if (!response.ok) throw new Error('unavailable');
    const data: unknown = await response.json();
    if (!data || typeof data !== 'object' || !('id' in data) || data.id !== submission.id || !('emailDelivery' in data) || data.emailDelivery !== 'not_configured') throw new Error('invalid_response');
    return { id: submission.id, emailDelivery: 'not_configured' };
  } finally { clearTimeout(timer); }
}
